import Skeleton from "@mui/material/Skeleton";

import { Box, Card, CardContent, CardHeader, Divider, Grid, Paper } from "@mui/material";

import { styles } from "../../style";

export const skeleton = (
    <>
        <Paper sx={{ ...styles.card, mb: "1rem", padding: "20px 24px" }}>
            <Skeleton variant="rounded" width="40%" height={16} />
            <Skeleton sx={{ mt: "0.5rem" }} variant="rounded" width="55%" height={10} />
        </Paper>

        <Box
            display={"flex"}
            alignItems={{
                xs: "flex-start",
                sm: "center",
            }}
            justifyContent={"space-between"}
            flexDirection={{
                xs: "column",
                sm: "row",
            }}
            sx={(theme) => ({
                width: "100%",
                [theme.breakpoints.down("sm")]: {
                    "&>*": {
                        width: "100%",
                        marginTop: "1rem",

                        "&:first-of-type": {
                            marginTop: 0,
                        },
                    },
                },
            })}
        >
            <Box display={"flex"} width={{ xs: "60%", sm: "25%" }} justifyContent={"start"} alignItems={"center"}>
                <Skeleton variant="rounded" width="80%" height={16} />
                <Skeleton variant="rounded" width="100%" height={40} sx={{ marginLeft: "0.5rem" }} />
            </Box>
            <Box width={{ xs: "60%", sm: "25%" }}>
                <Skeleton variant="rounded" width="100%" height={40} />
            </Box>
        </Box>

        <Box>
            {Array.from({ length: 3 }).map((_, index) => {
                return (
                    <Card
                        key={index}
                        sx={{
                            ...styles.card,
                            mt: "15px",
                            backgroundColor: "white",
                        }}
                    >
                        <CardHeader
                            sx={{
                                padding: {
                                    sm: "16px 24px",
                                    xs: "16px 16px",
                                },

                                width: "100%",
                                // borderBottom: "1px solid #ededed",

                                "& .MuiCardHeader-action": {
                                    display: "flex",

                                    alignItems: "center",
                                    justifyContent: "flex-end",
                                    // flexDirection: "column",

                                    width: "50%",
                                    margin: 0,
                                    marginTop: "0.5rem",
                                },

                                "& .MuiCardHeader-content ": {
                                    width: "50%",

                                    "& .MuiTypography-root": {
                                        width: "100%",
                                    },
                                },
                            }}
                            title={
                                <>
                                    <Skeleton
                                        variant="rounded"
                                        height={16}
                                        sx={{
                                            width: {
                                                xs: "30%",
                                                sm: "25%",
                                            },
                                        }}
                                    />
                                    <Skeleton
                                        variant="rounded"
                                        height={20}
                                        sx={{
                                            marginTop: "0.5rem",
                                            width: {
                                                xs: "50%",
                                                sm: "35%",
                                            },
                                        }}
                                    />
                                </>
                            }
                            action={
                                <>
                                    <Skeleton
                                        variant="rounded"
                                        height={16}
                                        sx={{
                                            width: {
                                                xs: "30%",
                                                sm: "25%",
                                            },
                                        }}
                                    />
                                    <Skeleton
                                        variant="rounded"
                                        height={24}
                                        sx={{
                                            marginLeft: "0.5rem",

                                            width: {
                                                xs: "35%",
                                                sm: "20%",
                                            },
                                        }}
                                    />
                                </>
                            }
                        ></CardHeader>

                        <Divider sx={{ borderColor: "#f4f4f5", margin: "0 24px" }} />

                        <CardContent
                            sx={{
                                padding: {
                                    sm: "16px 24px",
                                    xs: "16px 16px",
                                },
                            }}
                        >
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={2.5} lg={1.8}>
                                    <Box width={"100%"} height={"100%"} display={"flex"} justifyContent={"center"} alignItems={"center"} flexDirection={"column"}>
                                        <>
                                            <Skeleton
                                                variant="reactangle"
                                                sx={{
                                                    width: { xs: "100px", sm: "100px" },
                                                    height: { xs: "100px", sm: "100px" },
                                                    borderRadius: "8px",
                                                    // marginLeft: "0.5rem",
                                                }}
                                            />
                                        </>

                                        <Skeleton variant="rounded" width="80%" height={16} sx={{ marginTop: "0.5rem" }} />
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={0.25} lg={0.25}>
                                    <Divider
                                        orientation="vertical"
                                        sx={{
                                            borderRightWidth: {
                                                xs: "0",
                                                sm: "thin",
                                            },
                                            borderTopWidth: {
                                                xs: "thin",
                                                sm: "0",
                                            },
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6.5} lg={5.2}>
                                    <Grid container spacing={4} rowSpacing={2}>
                                        <Grid item xs={12}>
                                            <Skeleton variant="rounded" width="15%" height={16} />
                                            <Skeleton variant="rounded" width="40%" height={16} sx={{ marginTop: "0.5rem" }} />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Skeleton variant="rounded" width="40%" height={16} />
                                            <Skeleton variant="rounded" width="60%" height={16} sx={{ marginTop: "0.5rem" }} />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Skeleton variant="rounded" width="40%" height={16} />
                                            <Skeleton variant="rounded" width="60%" height={16} sx={{ marginTop: "0.5rem" }} />
                                        </Grid>
                                    </Grid>
                                    <Box
                                        sx={{
                                            padding: "10px 14px",
                                            borderRadius: "10px",
                                            background: "#FAFBFC",

                                            marginTop: "1rem",
                                        }}
                                    >
                                        <Skeleton variant="rounded" width="20%" height={16} />
                                        <Skeleton variant="rounded" width="100%" height={10} sx={{ marginTop: "0.5rem" }} />
                                        <Skeleton variant="rounded" width="100%" height={10} sx={{ marginTop: "0.5rem" }} />
                                        <Skeleton variant="rounded" width="80%" height={10} sx={{ marginTop: "0.5rem" }} />
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={0.25} lg={0.25}>
                                    <Divider
                                        orientation="vertical"
                                        sx={{
                                            borderRightWidth: {
                                                xs: "0",
                                                sm: "thin",
                                            },
                                            borderTopWidth: {
                                                xs: "thin",
                                                sm: "0",
                                            },
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={2.5} lg={4.5}>
                                    <Box display={"flex"} flexDirection={"column"} justifyContent={"space-between"} width={"100%"} height={"100%"} minHeight={100}>
                                        <Skeleton variant="rounded" width="100%" height={"70%"} sx={{ minHeight: 100 }} />
                                        {/* <Skeleton variant="rounded" width="100%" height={"20%"} sx={{ marginTop: "0.5rem" }} /> */}
                                        <Box
                                            sx={{
                                                padding: "10px 14px",
                                                borderRadius: "10px",
                                                background: "#FAFBFC",

                                                marginTop: "1rem",
                                                width: "100%",
                                            }}
                                        >
                                            <Skeleton variant="rounded" width="20%" height={16} />
                                            <Skeleton variant="rounded" width="100%" height={10} sx={{ marginTop: "0.5rem" }} />
                                            <Skeleton variant="rounded" width="80%" height={10} sx={{ marginTop: "0.5rem" }} />
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                );
            })}
        </Box>
    </>
);
